import { ref } from 'vue';
import { defineStore } from "pinia";

export const usePremiumNudgeStore = defineStore('premium-nudge', () => {
    const showModal = ref(false);
    const closeCallBack = ref(null)
    
    const setShowModal = (callback) => {
        closeCallBack.value = callback;
        showModal.value = true;
    }
    
    const hideModal = () => {
        showModal.value = false;
        closeCallBack.value();
    }

    return {
        showModal,
        
        setShowModal,
        hideModal,
    }
})
